import type {
  BuyerRelationshipFavouriteCreateRequestType,
  BuyerRelationshipFavouriteCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBuyerRelationshipFavouriteCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: BuyerRelationshipFavouriteCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `buyer-relationship-favourite/v2`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as BuyerRelationshipFavouriteCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.BuyerRelationship],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.FavouriteNotificationPreferences,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Relationships],
      });
    },
  });
};
